module.exports = __webpack_public_path__ + "img/bannerImg_mobile.b6087baf.png";